import { render, staticRenderFns } from "./activate2.vue?vue&type=template&id=39511aab&scoped=true"
import script from "./activate2.vue?vue&type=script&lang=js"
export * from "./activate2.vue?vue&type=script&lang=js"
import style0 from "../assets/list.scss?vue&type=style&index=0&id=39511aab&prod&lang=scss&scoped=true&external"
import style1 from "../assets/css/index.scss?vue&type=style&index=1&id=39511aab&prod&lang=scss&scoped=true&external"
import style2 from "./activate2.vue?vue&type=style&index=2&id=39511aab&prod&lang=css"
import style3 from "../assets/css/mobile.scss?vue&type=style&index=3&id=39511aab&prod&lang=scss&scoped=true&external"
import style4 from "./activate2.vue?vue&type=style&index=4&id=39511aab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39511aab",
  null
  
)

export default component.exports